// @ts-nocheck
import { interactivityRegistration } from "./Charta";
import { DomQuery, HtmlClassSwitch, WithClass } from "./Dom";
import { clickElement } from "./Event";
import { FileDropZone } from "./WebSite.Page.Component.DropZone.File_";
import { connectClickOutsideListener, removeClickOutsideListener } from "./WebSite.Page.Component";

export function ProgressBar(phases) {
    this.createElement = function () {
        const result = document.createElement("div");
        result.className = "ProgressBar"

        for (let index = 0; index < this.phases; index++) {
            const indicator = result.appendChild(document.createElement("div"));
            indicator.className = "Indicator";
            indicator.style.opacity = Math.pow(0.5, this.phases - index);

            this.indicators.push(indicator);
        }

        this.indicator = result.appendChild(document.createElement("div"));
        this.indicator.className = "Indicator";
        this.indicator.innerHTML = "0%";

        return result;
    }

    this.setProgress = function (progress, phase) {
        for (let index = 0; index < progress.length; index++) {
            this.indicators[index].style.width = progress[index] + "%";

            if (index === phase) {
                this.progress = progress[index];
                this.indicator.innerHTML = (progress[index].toFixed(2)) + "%";
            }
        }
    }

    this.phases = phases;
    this.progress = 0;
    this.indicators = new Array();
    this.element = this.createElement();
}

export class FileField extends FileDropZone {
  constructor(element) {
    super(element);

    this.initialize();
    this.build();
    this.attachHandlers();
  }

  attachHandlers() {
    if (this.mode === "edit") {
      this.icon.onclick = (event) => { clickElement(this.input); };
      this.clear.onclick = (event) => { this.setValue(null); };
      this.input.onchange = (event) => { this.valueChanged(); };

      this.fileName.onclick = (event) => {
        if (this.value != null) {
          this.openPreview();
          event.stopPropagation();
        }
      };
    }
    else {
      if (this.value !== null) {
        this.fileName.onclick = (event) => {
          this.openPreview();
          event.stopPropagation();
        };

        this.fileName.draggable = true;
        this.fileName.addEventListener(
          "dragstart",
          (event) => {
            event.dataTransfer.setData("DownloadURL", "application/octet-stream:" + this.getFileName() + ":" + this.getUri());
            event.dataTransfer.setData("File", this.getUri());
            event.dataTransfer.setData("FileName", this.getFileName());
          },
          false
        );
      }
    }

    this.preview.onscroll = (event) => { event.stopPropagation(); };
  }

  createButton(caption) {
    const result = document.createElement("input");
    result.type = "button";
    result.value = caption;

    return result;
  }

  createDownloadButton() {
    const result = document.createElement("a");
    result.classList.add("button");
    result.classList.add("Action");
    result.href = this.uri;
    result.download = this.getFileName();
    result.innerHTML = "Download";

    return result;
  }

  enableDownloadButton(enabled) {
    new HtmlClassSwitch(this.downloadButton, "Disabled").setStatus(!enabled);

    if (enabled)
      this.downloadButton.href = this.uri;
    else
      this.downloadButton.href = "javascript:void(0);";
  }

  createToolBar() {
    this.downloadButton = this.createDownloadButton();

    const fileNameLabel = document.createElement("span");
    fileNameLabel.classList.add("FileName");
    fileNameLabel.innerHTML = this.getFileName();

    const result = document.createElement("div");
    result.classList.add("ToolBar");
    result.appendChild(this.downloadButton);
    result.appendChild(fileNameLabel);

    return result;
  }

  build() {
    this.element.innerHTML = "";

    this.fileName = document.createElement("div");
    this.fileName.classList.add("FileName");

    if (this.value !== null)
      this.fileName.innerHTML = this.value;

    if (this.mode === "edit") {
      this.valueField = document.createElement("input");
      this.valueField.type = "hidden";
      this.valueField.value = this.element.dataset.State;
      this.valueField.name = this.element.dataset.HierarchicalName;

      this.input = document.createElement("input");
      this.input.type = "file";
      this.input.style.display = "none";
      this.input.accept = this.element.dataset.Accept;

      this.icon = document.createElement("div");
      this.icon.classList.add("Icon");

      this.clear = document.createElement("div");
      this.clear.classList.add("Clear");

      this.progressBar = document.createElement("div");
      this.progressBar.classList.add("ProgressBar");

      if (this.value === null)
        this.fileName.innerHTML = this.hint;

      this.element.appendChild(this.valueField);
      this.element.appendChild(this.input);
      this.element.appendChild(this.icon);
      this.element.appendChild(this.fileName);
      this.element.appendChild(this.clear);
      this.element.appendChild(this.progressBar);
    }
    else
      this.element.appendChild(this.fileName);

    this.toolBar = this.createToolBar();

    this.previewContent = document.createElement("div");
    this.previewContent.classList.add("Contents");

    this.previewWindow = document.createElement("div");
    this.previewWindow.classList.add("Window");
    this.previewWindow.appendChild(this.toolBar);
    this.previewWindow.appendChild(this.previewContent);

    this.preview = document.createElement("div");
    this.preview.classList.add("Preview");
    this.preview.appendChild(this.previewWindow);
    this.preview.onclick = (event) => { event.stopPropagation(); };

    this.element.appendChild(this.preview);
  }

  getFileName() {
    return this.fileName.innerHTML;
  }

  getUri() {
    return this.uri + "/" + this.fileName.innerHTML;
  }

  handleFiles(files) {
    this.setValue(files[0]);
  }

  initialize() {
    this.mode = this.element.dataset.Mode;
    this.uri = this.element.dataset.Uri;
    this.hint = this.element.dataset.Hint;
    this.confirmationRequired = this.element.dataset.ConfirmationRequired === "true";

    if (this.element.dataset.Value !== undefined)
      this.value = this.element.dataset.Value;
    else
      this.value = null;

    if (this.mode === "edit" && this.value !== null)
      this.element.classList.add("Selected");

    this.initializeDropZone();
  }

  isEnabled() {
    return this.mode === "edit";
  }

  showPreview(content) {
    this.previewContent.innerHTML = content;
  }

  retrievePreview() {
    const xmlHttpRequest = new XMLHttpRequest();
    xmlHttpRequest.open("GET", this.uri + "/Preview");

    xmlHttpRequest.onreadystatechange = (event) => {
      if (xmlHttpRequest.readyState === 4)
        this.showPreview(xmlHttpRequest.responseText);
    };

    xmlHttpRequest.send();
  }

  acceptConfirmation() {
    const xmlHttpRequest = new XMLHttpRequest();
    xmlHttpRequest.open("POST", this.uri + "/Confirmation");

    xmlHttpRequest.onreadystatechange = (event) => {
      if (xmlHttpRequest.readyState === 4) {
        this.enableDownloadButton(true);
        this.confirmationRequired = false;
        this.retrievePreview();
      }
    };

    xmlHttpRequest.send();
  }

  showConfirmation(content) {
    const confirmationContentsPanel = document.createElement("div");
    confirmationContentsPanel.classList.add("ConfirmationContentsPanel");
    confirmationContentsPanel.innerHTML = content;

    const confirmationMessage = new DomQuery(confirmationContentsPanel).getChild(WithClass("ConfirmationMessage"));
    const unconfirmableMessage = new DomQuery(confirmationMessage).getChild(WithClass("Unconfirmable"));

    const confirmable = confirmationMessage.dataset.Confirmable === "true";

    const acceptButton = this.createButton("Accept");
    acceptButton.disabled = !confirmable;
    acceptButton.onclick = (event) => {
      this.acceptConfirmation();
      event.stopPropagation();
    };

    const toolBar = document.createElement("div");
    toolBar.classList.add("ToolBar");
    toolBar.appendChild(acceptButton);

    if (unconfirmableMessage !== null)
      toolBar.appendChild(unconfirmableMessage);

    const confirmationPanel = document.createElement("div");
    confirmationPanel.classList.add("ConfirmationPanel");
    confirmationPanel.appendChild(confirmationContentsPanel);
    confirmationPanel.appendChild(toolBar);

    this.previewContent.innerHTML = "";
    this.previewContent.appendChild(confirmationPanel);
  }

  retrieveConfirmation() {
    const xmlHttpRequest = new XMLHttpRequest();
    xmlHttpRequest.open("GET", this.uri + "/Confirmation");

    xmlHttpRequest.onreadystatechange = (event) => {
      if (xmlHttpRequest.readyState === 4)
        this.showConfirmation(xmlHttpRequest.responseText);
    };

    xmlHttpRequest.send();
  }

  openPreview() {
    this.enableDownloadButton(!this.confirmationRequired);
    this.preview.classList.add("Expanded");

    const listener = connectClickOutsideListener(
      this.previewWindow,
      (event) => {
        this.preview.classList.remove("Expanded");
        this.previewContent.innerHTML = "";
        event.stopPropagation();
        removeClickOutsideListener(listener);
      }
    );

    if (this.confirmationRequired)
      this.retrieveConfirmation();
    else
      this.retrievePreview();
  }

  setProgress(progress) {
    this.progressBar.style.width = progress + "%";
  }

  setValue(file) {
    const xmlHttpRequest = new XMLHttpRequest();
    xmlHttpRequest.open("POST", this.uri);

    const formData = new FormData();
    formData.append("form", "Form");

    if (file == null) {
      formData.append("Name", "");
      formData.append("Contents", "");

      xmlHttpRequest.onreadystatechange = (event) => {
        if (xmlHttpRequest.readyState === 4) {
          this.element.classList.remove("Selected");
          this.fileName.innerHTML = this.hint;
          this.input.value = "";
          this.valueField.value = "Empty";

          if (this.valueField.onchange !== null)
            this.valueField.onchange();
        }
      };
    }
    else {
      this.element.classList.add("Uploading");
      this.fileName.innerHTML = file.name;

      formData.append("Name", file.name);
      formData.append("Contents", file);

      xmlHttpRequest.upload.onprogress = (event) => {
        if (event.lengthComputable) {
          const complete = (event.loaded / event.total * 100 | 0);
          this.setProgress(complete);
        }
      };

      xmlHttpRequest.onreadystatechange = (event) => {
        if (xmlHttpRequest.readyState === 4) {
          if (xmlHttpRequest.status === 200) {
            this.element.classList.add("Selected");
            this.value = file.name;
            this.valueField.value = "Input";

            if (this.valueField.onchange !== null)
              this.valueField.onchange();
          }
          else {
            this.value = null;
            this.fileName.innerHTML = this.hint;
          }

          this.element.classList.remove("Uploading");
          this.setProgress(0);
        }
      };
    }

    xmlHttpRequest.send(formData);
  }

  valueChanged() {
    if (this.input.files.length === 1)
      this.setValue(this.input.files[0]);
  }
}

interactivityRegistration.register("FileField", function (element) { return new FileField(element); });
